import jsonexport from 'jsonexport/dist'

let utils = {
  targetLink (db, id) {
    if (!db || db === 'CHEMBL') {
      return 'https://www.ebi.ac.uk/chembl/target_report_card/' + id
    } else if (db === 'Metabolites') {
      return 'http://www.hmdb.ca/metabolites/' + id
    }
  },

  compLink (db, id) {
    if (!db || db === 'CHEMBL') {
      return 'https://www.ebi.ac.uk/chembl/compound_report_card/' + id
    } else if (db === 'Metabolites') {
      return 'http://www.hmdb.ca/metabolites/' + id
    } else if (db === 'Zinc') {
      return 'http://zinc15.docking.org/substances/' + id
    }
  },

  smilesLink (smi) {
    let v = this
    let s = encodeURIComponent(smi)
    return `${v.$store.state.host}/dokhlab/actions/smiles2svg?smiles=${s}`
  },

  assayLink (db, id) {
    if (!db || db === 'CHEMBL') {
      return 'https://www.ebi.ac.uk/chembl/assay_report_card/' + id
    } else if (db === 'Metabolites') {
      return 'http://www.hmdb.ca/metabolites/' + id
    }
  },

  databaseLink (db) {
    if (!db || db === 'CHEMBL') {
      return 'https://www.ebi.ac.uk/chembl'
    } else if (db === 'Metabolites') {
      return 'http://www.hmdb.ca/metabolites'
    } else {
      return 'https://zinc15.docking.org'
    }
  },

  scrollById (id) {
    document.getElementById(id).scrollIntoView()

    var scrolledY = window.scrollY
    var height = document.getElementById('simcomp-top-scroll').offsetHeight + 300

    if (scrolledY) {
      window.scroll(0, scrolledY - height)
    }
  },

  openNewTab (url) {
    window.open(url, '_blank')
  },

  redirect (url) {
    window.location.href = url
  },

  toFixed (x, n) {
    return Number.parseFloat(x).toFixed(n)
  },

  safeLocaleCompare (a, b) {
    if (!a && b) {
      return 1
    } else if (a && !b) {
      return -1
    } else if (!a && !b) {
      return 0
    } else {
      return a.localeCompare(b)
    }
  },

  safeLocaleCompareStringArray (a, b) {
    if (!a) {
      a = []
    }
    if (!b) {
      b = []
    }
    a = a.join('')
    b = b.join('')
    return utils.safeLocaleCompare(a, b)
    // if (!a && b) {
    //   return 1
    // } else if (a && !b) {
    //   return -1
    // } else if (!a && !b) {
    //   return 0
    // } else {
    //   return a.localeCompare(b)
    // }
  },

  getTargets (compounds) {
    let ls = {}
    for (let i in compounds) {
      let compound = compounds[i]
      for (let j in compound.targets) {
        let target = compound.targets[j]
        target.compound = i
        if (!(target.id in ls)) {
          ls[target.id] = []
        }
        ls[target.id].push(target)
      }
    }
    return ls
  },

  uniq (a) {
    return a.filter(function (item, pos) {
      return a.indexOf(item) === pos
    })
  },

  download (str, name) {
    var blob = new Blob([str], { type: 'text/csv;charset=utf-8;' })
    var link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', name)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },

  saveCsv (object, name) {
    jsonexport(object, function (err, csv) {
      if (err) {
        console.log(err)
      }
      utils.download(csv, name)
    })
  },

  targetFunctionMap (compounds) {
    let functions = {}
    for (let compound of compounds) {
      for (let target of compound.targets) {
        if (!(target.id in functions)) {
          functions[target.id] = []
          for (let func of target.functions) {
            functions[target.id].push(func)
          }
        }
      }
    }
    return functions
  },

  targetProcessMap (compounds) {
    let processes = {}
    for (let compound of compounds) {
      for (let target of compound.targets) {
        if (!(target.id in processes)) {
          processes[target.id] = []
          for (let proc of target.processes) {
            processes[target.id].push(proc)
          }
        }
      }
    }
    return processes
  },

  getTargetNames (compounds) {
    let names = []
    for (let compound of compounds) {
      for (let target of compound.targets) {
        let i = names.findIndex((n) => {
          return n.name === target.pref_name
        })
        if (i === -1) {
          names.push({name: target.pref_name, num: 0})
        } else {
          names[i].num += 1
        }
      }
    }
    names.sort((a, b) => { return b.num - a.num })

    return names
  },

  getTargetOrganisms (compounds) {
    let organisms = []
    for (let compound of compounds) {
      for (let target of compound.targets) {
        let i = organisms.findIndex((n) => {
          return n.organism === target.organism
        })
        if (i === -1) {
          organisms.push({organism: target.organism, num: 0})
        } else {
          organisms[i].num += 1
        }
      }
    }
    organisms.sort((a, b) => { return b.num - a.num })

    return organisms
  },

  mapUtils (actions) {
    let r = {}
    for (let action of actions) {
      r[action] = utils[action]
    }
    return r
  }
}

export default utils
